module.exports = __webpack_public_path__ + "static/media/doclad2.5f00bdd9.pdf";